var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","centered":"","size":"lg","title":(_vm.editing ? 'Editar' : 'Crear') + ' GES'},model:{value:(_vm.modal.show),callback:function ($$v) {_vm.$set(_vm.modal, "show", $$v)},expression:"modal.show"}},[_c('hygienic_measurement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }